/**
 * Date-extensions locale Hindi [hi]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('hi', {
    monthNames: ['जनवरी','फ़रवरी','मार्च','अप्रैल','मई','जून','जुलाई','अगस्त','सितम्बर','अक्टूबर','नवम्बर','दिसम्बर'],
    monthShortNames: ['जन.','फ़र.','मार्च','अप्रै.','मई','जून','जुल.','अग.','सित.','अक्टू.','नव.','दिस.'],
    dayNames: ['रविवार','सोमवार','मंगलवार','बुधवार','गुरूवार','शुक्रवार','शनिवार'],
    dayShortNames: ['रवि','सोम','मंगल','बुध','गुरू','शुक्र','शनि']
});
